export default __webpack_public_path__ + "static/media/5-glygen-warren-workshop.0739033d.pdf";